// @flow
import {
    INIT_MENU,
    INIT_MENU_SUCCESS,
    CHANGE_ACTIVE_MENU_FROM_LOCATION,
    CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    FETCH_MAINTENANCE_REQUEST_BADGE,
    FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS,
    FETCH_CHAT_USER_BADGE,
    FETCH_CHAT_USER_BADGE_SUCCESS,
    FETCH_CHAT_TECHNICIAN_BADGE,
    FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS,
} from './constants';


const AppMenu = (state = {}, action) => {
    switch (action.type) {
        case INIT_MENU:
            return action.payload;
        case INIT_MENU_SUCCESS:
            return { ...state, ...action.payload };
        case CHANGE_ACTIVE_MENU_FROM_LOCATION:
            return { ...state };
        case CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS:
            return { ...state, ...action.payload };
        case FETCH_MAINTENANCE_REQUEST_BADGE:
            return { ...state };
        case FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS:
            return { ...state, ...action.payload };
        case FETCH_CHAT_USER_BADGE:
            return { ...state };
        case FETCH_CHAT_USER_BADGE_SUCCESS:
            return { ...state, ...action.payload };
        case FETCH_CHAT_TECHNICIAN_BADGE:
            return { ...state };
        case FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default AppMenu;
